<template>
  <div class="artifact-readonly">
    <div class="toolbar">
      <el-input
          v-model.trim="selectKey"
          clearable
          placeholder="请输入型号、图纸号、厂商或工序"
          class="filter-input"
          @keyup.enter.native="applyFilter">
      </el-input>
      <el-button type="primary" @click="applyFilter">筛选</el-button>
      <el-button @click="resetFilter">重置</el-button>
      <el-button icon="el-icon-refresh" @click="select">刷新</el-button>
    </div>

    <el-table
        :data="tableDataShow"
        border
        v-loading="loading"
        style="width: 100%">
      <el-table-column
          v-if="false"
          fixed="left"
          label="id"
          prop="id"
          width="100">
      </el-table-column>
      <el-table-column
          fixed="left"
          label="工件型号"
          prop="xinghao"
          width="200">
      </el-table-column>
      <el-table-column
          fixed="left"
          label="图纸号"
          prop="tuzhihao"
          width="200">
      </el-table-column>
      <el-table-column
          fixed="left"
          label="厂商"
          prop="changshang"
          width="100">
      </el-table-column>
      <el-table-column
          label="工件数量"
          prop="number"
          width="100">
      </el-table-column>
      <el-table-column
          label="入厂时间"
          prop="data"
          width="130">
      </el-table-column>
      <el-table-column
          label="发货时间"
          prop="sendtime"
          width="160">
      </el-table-column>
      <el-table-column
          v-for="column in processColumns"
          :key="column.prop"
          :label="column.label"
          :prop="column.prop"
          width="80">
        <template slot-scope="scope">
          {{ getProcessName(scope.row, column.index) }}
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          label="查看"
          width="120">
        <template slot-scope="scope">
          <el-button
              type="text"
              :disabled="!scope.row.xinghao"
              @click="getPhotoUrl(scope.row.xinghao + '(内部填报)')">
            查看二维码
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
          :current-page="currentPage4"
          :page-size="size"
          :page-sizes="[5, 10, 20]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <el-dialog :visible.sync="showQR" :title="QRName" width="20%" destroy-on-close>
      <img v-if="url" :src="url" alt="" class="qr-image">
      <div v-else class="empty-qr">暂无二维码</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQR = false">关闭</el-button>
        <el-button type="primary" :disabled="!url" @click="img_download">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "ArtifactManageOnlyRead",
  data() {
    return {
      loading: false,
      showQR: false,
      url: "",
      QRName: "",
      currentPage4: 1,
      size: 10,
      total: 0,
      tableData: [],
      tableDataShow: [],
      selectKey: "",
      processColumns: Array.from({ length: 15 }, (_, index) => {
        return {
          index,
          label: `工序${index + 1}`,
          prop: `gongxu[${index}]`
        }
      })
    }
  },
  mounted() {
    this.select()
  },
  methods: {
    select() {
      this.loading = true
      request.post("/ArtifactManage").then(res => {
        if (res.code !== undefined && res.code.toString() !== "200") {
          this.$notify.error({
            title: "错误",
            message: res.code + ":" + res.msg
          })
          return
        }

        this.tableData = Array.isArray(res.data) ? res.data : []
        this.getTableDateShow()
      }).catch(() => {
        this.$notify.error({
          title: "错误",
          message: "工件列表获取失败"
        })
      }).finally(() => {
        this.loading = false
      })
    },
    applyFilter() {
      this.currentPage4 = 1
      this.getTableDateShow()
    },
    resetFilter() {
      this.selectKey = ""
      this.currentPage4 = 1
      this.getTableDateShow()
    },
    getTableDateShow() {
      const keyword = (this.selectKey || "").trim()
      let tableData = this.tableData.concat()

      if (keyword !== "") {
        tableData = tableData.filter(item => this.matchKeyword(item, keyword))
      }

      this.total = tableData.length

      const pageMax = Math.ceil(this.total / this.size)
      this.currentPage4 = this.currentPage4 > pageMax ? pageMax : this.currentPage4
      this.currentPage4 = this.currentPage4 < 1 ? 1 : this.currentPage4

      this.tableDataShow = tableData.slice((this.currentPage4 - 1) * this.size, this.currentPage4 * this.size)
    },
    matchKeyword(row, keyword) {
      const lowerKeyword = keyword.toLowerCase()
      const gongxu = Array.isArray(row.gongxu) ? row.gongxu : []
      const fields = [
        row.xinghao,
        row.tuzhihao,
        row.changshang,
        row.number,
        row.data,
        row.sendtime,
        ...gongxu
      ]

      return fields.some(value => {
        return (value || "").toString().toLowerCase().indexOf(lowerKeyword) > -1
      })
    },
    getProcessName(row, index) {
      if (!row || !Array.isArray(row.gongxu)) {
        return ""
      }
      return row.gongxu[index] || ""
    },
    handleSizeChange(val) {
      this.size = val
      this.currentPage4 = 1
      this.getTableDateShow()
    },
    handleCurrentChange(val) {
      this.currentPage4 = val
      this.getTableDateShow()
    },
    encodeQRName(name) {
      return (name || "").toString()
          .split("+").join("%2B")
          .split("/").join("%26")
          .split("?").join("%3F")
          .split("#").join("%23")
          .split("&").join("%26")
          .split("=").join("%3D")
          .split("\n").join("")
          .split(" ").join("")
    },
    getPhotoUrl(name) {
      this.QRName = name
      this.url = "https://gate.yilanbiaoge.cn/back/getQRcode/" + this.encodeQRName(name)
      this.showQR = true
    },
    getBlob() {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()

        xhr.open("GET", this.url, true)
        xhr.responseType = "blob"
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          } else {
            reject(new Error("download failed"))
          }
        }
        xhr.onerror = () => reject(new Error("download failed"))

        xhr.send()
      })
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement("a")
        const body = document.querySelector("body")

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.style.display = "none"
        body.appendChild(link)

        link.click()
        body.removeChild(link)

        window.URL.revokeObjectURL(link.href)
      }
    },
    img_download () {
      this.getBlob().then(blob => {
        this.saveAs(blob, this.QRName + ".png")
      }).catch(() => {
        this.$notify.error({
          title: "错误",
          message: "二维码下载失败"
        })
      })
    }
  }
}
</script>

<style scoped>
.artifact-readonly {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
}

.filter-input {
  width: 260px;
}

.pagination-wrap {
  margin: 10px 0;
}

.qr-image {
  width: 100%;
  display: block;
}

.empty-qr {
  line-height: 120px;
  text-align: center;
  color: #909399;
}
</style>
